import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/responsibleConsumption/importer/responsibleConsumptionImporterActions';

export default importerReducers(actions);
